// Copyright © 2015-2020 TrampleZone LLC All Rights Reserved

// ChitikaPlatform Module

// This module provides support for advertising in the Client application.
// There are several different types of desktop ads supported: banners,
// verticalbanners, smallsquares, squares, leaderboards, skyscrapers,
// and interstitials.  NOTE: There are 2 verticalbanners as they are small.
//
// Support for throttling display rate is also provided.  For example,
// one can decide to only show an ad in the slot a certain percentage of the
// time.  This is important to be responsive to user input and maximize
// ad revenue and user satisfaction.
//
// Sample Chitika code
//  <script type="text/javascript">
//  ( function() {
//    if (window.CHITIKA === undefined) { window.CHITIKA = { 'units' : [] }; };
//    var unit = {"calltype":"async[2]","publisher":"jmelvin","width":728,"height":90,"sid":"Chitika Default"};
//    var placement_id = window.CHITIKA.units.length;
//    window.CHITIKA.units.push(unit);
//    document.write('<div id="chitikaAdBlock-' + placement_id + '"></div>');
//  }());
//  </script>
//  <script type="text/javascript" src="//cdn.chitika.net/getads.js" async></script>

define('ChitikaPlatform',['require','Policies','Utilities'],function (require) {
    'use strict';

    var // Require.js module dependencies
        Policies = require('Policies'),
        Utilities = require('Utilities'),

        // Common
        policies,
        utilities,
        platformName = 'Chitika',   // Name of the ad platform in use
        initialized,                // True if ad platform was initialized
        bannerRate = 1.0,           // How frequently to show banner ads
        interstitialRate = 0.3,     // How frequently to show interstitials
        publisherId,                // Publisher ID for advertising
        adSlots,                    // Advertising credentials

        // Other
        main,
        script,
        adDiv;


    // Constructor
    function ChitikaPlatform () {

        // Dependent resources
        policies = new Policies();
        utilities = new Utilities();

        // Public Methods

        // Set Google Publisher ID
        this.setPublisherId = function () {
            publisherId = policies.getPolicy('chitikaPublisherId');
        };

        // Set Ad Slots
        this.setAdSlots = function () {
            // Credentials
            adSlots = {
                banner: {
                    adClient:           publisherId,
                    adSlot:             policies.getPolicy(
                                            'chitikaBannerAdSlot') || '',
                    displayRate:        bannerRate,
                    width:              '320px',
                    height:             '50px',
                    adReady:            false,
                    isAdShowing:        false
                },
                verticalbanner1: {
                    adClient:           publisherId,
                    adSlot:             policies.getPolicy(
                                            'chitikaVerticalbanner1AdSlot') || '',
                    displayRate:        bannerRate,
                    width:              '120px',
                    height:             '240px',
                    adReady:            false,
                    isAdShowing:        false
                },
                verticalbanner2: {
                    adClient:           publisherId,
                    adSlot:             policies.getPolicy(
                                            'chitikaVerticalbanner2AdSlot') || '',
                    displayRate:        bannerRate,
                    width:              '120px',
                    height:             '240px',
                    adReady:            false,
                    isAdShowing:        false
                },
                leaderboard: {
                    adClient:           publisherId,
                    adSlot:             policies.getPolicy(
                                            'chitikaLeaderboardAdSlot') || '',
                    displayRate:        bannerRate,
                    width:              '728px',
                    height:             '90px',
                    adReady:            false,
                    isAdShowing:        false
                },
                smallsquare: {
                    adClient:           publisherId,
                    adSlot:             policies.getPolicy(
                                            'chitikaSmallsquareAdSlot') || '',
                    displayRate:        bannerRate,
                    width:              '200px',
                    height:             '200px',
                    adReady:            false,
                    isAdShowing:        false
                },
                square: {
                    adClient:           publisherId,
                    adSlot:             policies.getPolicy(
                                            'chitikaSquareAdSlot') || '',
                    displayRate:        bannerRate,
                    width:              '250px',
                    height:             '250px',
                    adReady:            false,
                    isAdShowing:        false
                },
                skyscraper: {
                    adClient:           publisherId,
                    adSlot:             policies.getPolicy(
                                            'chitikaSkyscraperAdSlot') || '',
                    displayRate:        bannerRate,
                    width:              '160px',
                    height:             '600px',
                    adReady:            false,
                    isAdShowing:        false
                }
            };
        };

        // Set the display rate for banner ads
        this.setAdSlotDisplayRate = function (newBannerRate) {
            // Desktop rates
            adSlots.banner.displayRate          = bannerRate;
            adSlots.verticalbanner1.displayRate = bannerRate;
            adSlots.verticalbanner2.displayRate = bannerRate;
            adSlots.square.displayRate          = bannerRate;
            adSlots.smallsquare.displayRate     = bannerRate;
            adSlots.leaderboard.displayRate     = bannerRate;
            adSlots.skyscraper.displayRate      = bannerRate;
        };

        // Set the display rate for interstitial ads
        this.setInterstitialDisplayRate = function (newInterstitialRate) {
            // Unsupported for now
        };

        // Set ad display Rates based on policies
        this.setDisplayRates = function () {
            // Ad Slots
            var newBannerRate = policies.getPolicy('adDisplayRateBanner');
            if (newBannerRate) {
                this.setAdSlotDisplayRate(parseFloat(newBannerRate));
            }
            // Interstitials
            var newInterstitialRate =
                    policies.getPolicy('adDisplayRateInterstitial');
            if (newInterstitialRate) {
                this.setInterstitialDisplayRate(parseFloat(newInterstitialRate));
            }
        };
    };

    // Public Prototype Methods

    // Initializations
    ChitikaPlatform.prototype.initialize = function (newMain) {
        // Save reference to Main.js
        main = newMain;

        // Set advertising credentials from Server policies
        this.setPublisherId();
        this.setAdSlots();

        // Set display rates from Server policies
        this.setDisplayRates();

        // Set initial state
        initialized = true;
    };

    // Show ad in specified element
    ChitikaPlatform.prototype.showAd = function (
        visible, type, parentDiv, callback) {

        // Construct and show new ad if requested
        if (visible && !adSlots[type].isAdShowing) {

            // Initialize or access singleton
            window.CHITIKA = window.CHITIKA || { 'units': [] };

            // Turn off 'adhesion' as it screws up mobile
            window.CHITIKA.no_adhesion = 'true';

            // Check for an existing ad of this type and slot id
            var adExists = false,
                units = window.CHITIKA.units,
                length = units.length;
            for (var i=0; i<length; i++) {
                if (units[i].sid == adSlots[type].adSlot) {
                    adExists = true;
                    break;
                }
            }

            // Create new ad only if necessary
            if (!adExists) {
                // Define the ad unit
                var unit = {
                        calltype: 'async[2]',
                        publisher: adSlots[type].adClient,
                        sid: adSlots[type].adSlot,
                        width: parseInt(adSlots[type].width),
                        height: parseInt(adSlots[type].height),
                        color_button: '0E8CD9',
                        color_button_text: '000000'
                    },
                    placement_id = units.length;

                // Add the ad unit to the collection
                units.push(unit);

                // Create script tags for platform
                script = document.createElement('script');
                script.setAttribute('src','https://cdn.chitika.net/getads.js');

                // Create the ad div
                adDiv = document.createElement('div');
                adDiv.setAttribute('id', 'chitikaAdBlock-' + placement_id);
                adDiv.style.width = adSlots[type].width;
                adDiv.style.height = adSlots[type].height;

                // Parent should be full size, just in case
                parentDiv.style.width = adDiv.style.width;
                parentDiv.style.height = adDiv.style.height;

                // Assemble
                adDiv.appendChild(script);
                parentDiv.appendChild(adDiv);
            }
        }

        // Show or hide
        parentDiv.style.display = (visible ? 'inline-block' : 'none');

        // Record that ad is currently [not] showing
        adSlots[type].isAdShowing = visible;

        // Notify listeners if any
        if (callback) {
            callback();
        }
    };

    // Show small banner ad
    ChitikaPlatform.prototype.showBannerAd = function (
        visible, parentDiv, callback) {
        this.showAd(visible, 'banner', parentDiv, callback);
    };

    // Show verticalbanner ad1
    ChitikaPlatform.prototype.showVerticalbanner1Ad = function (
        visible, parentDiv, callback) {
        this.showAd(visible, 'verticalbanner1', parentDiv, callback);
    };

    // Show verticalbanner ad2
    ChitikaPlatform.prototype.showVerticalbanner2Ad = function (
        visible, parentDiv, callback) {
        this.showAd(visible, 'verticalbanner2', parentDiv, callback);
    };

    // Show leaderboard ad
    ChitikaPlatform.prototype.showLeaderboardAd = function (
        visible, parentDiv, callback) {
        this.showAd(visible, 'leaderboard', parentDiv, callback);
    };

    // Show small square ad
    ChitikaPlatform.prototype.showSmallSquareAd = function (
        visible, parentDiv, callback) {
        this.showAd(visible, 'smallsquare', parentDiv, callback);
    };

    // Show square ad
    ChitikaPlatform.prototype.showSquareAd = function (
        visible, parentDiv, callback) {
        this.showAd(visible, 'square', parentDiv, callback);
    };

    // Show skyscraper ad
    ChitikaPlatform.prototype.showSkyscraperAd = function (
        visible, parentDiv, callback) {
        this.showAd(visible, 'skyscraper', parentDiv, callback);
    };

    // Get Ad platform name
    ChitikaPlatform.prototype.getAdPlatform = function () {
        return platformName;
    };

    // Return Constructor
    return ChitikaPlatform.prototype.constructor;
});

